import { hexToRgb } from './hexToRgb';

export function invertColor(hexColor: string) {
  const [r, g, b] = hexToRgb(hexColor).map((v) => 255 - v);
  // simple version of rgb-hex
  return '#' + (b | (g << 8) | (r << 16) | (1 << 24)).toString(16).slice(1); // eslint-disable-line no-mixed-operators
}
